import { Pagination, Table, TBody, TH, THead, TR } from '@sede-enterprise/shell-ds-react-framework';
import React, { useState } from 'react';

const FilePreview = ({ data, headers, fileName }) => {
    const itemsPerPage = 5;
    const [pageSize, setPageSize] = useState(1);

    const indexOfLastItem = pageSize * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const displayItems = data?.slice(
        indexOfFirstItem,
        indexOfLastItem
    );

    const round = (number, digits) => {
        if (isNaN(number)) {
            return number
        }else{
            number = Number(number);
        }

        if (number === 0) {
            return 0;
        }
        else {
            return Math.round(number * (Math.pow(10, digits))) / Math.pow(10, digits) || "NA";
        }
    };

    return data?.length > 0 && (
        <>
            <div className='file-preview-header'>
                <h4 className='file-preview-title'>File Preview: {fileName || 'No file uploaded'}</h4>
            </div>
            <div className='file-preview-container'>
                <Table className='file-preview-table'

                >
                    <THead>
                        <TR>
                            {headers.map((header, index) => (
                                <TH key={index}>{header}</TH>
                            ))}
                        </TR>
                    </THead>
                    <TBody>
                        {displayItems.map((row, index) => (
                            <TR key={index}>
                                {row.map((cell, cellIndex) => (
                                    <TH key={cellIndex}>{round(cell, 3)}</TH>
                                ))}
                            </TR>
                        ))}
                    </TBody>
                </Table>
            </div>
            {itemsPerPage < data?.length && (
                <Pagination
                    current={pageSize}
                    total={data?.length}
                    pageSize={itemsPerPage}
                    onChange={_ => {
                        setPageSize(_);
                    }}
                />
            )}


        </>

    );
};

export default FilePreview;